import { render, staticRenderFns } from "./TopAds.vue?vue&type=template&id=29dd8329&scoped=true&"
import script from "./TopAds.vue?vue&type=script&lang=js&"
export * from "./TopAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd8329",
  null
  
)

export default component.exports